import {InfoItem, SectionTitle} from '@/components/molecules'
import {PageContainer} from '@/components/organisms'
import {capitalizeFirst,formatDateToYMD} from '@/helpers/shadcn/utils'

const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const DisplayRewards = ({rewardsDetails}) => (
  <>
    {/* Rewards Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="rewards" title="Rewards" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Processed Status" value={capitalizeFirst(rewardsDetails?.processedStatus)} />
        <InfoItem label="Rewards Processed Date" value={formatDateToYMD(rewardsDetails?.rewardsProcessedDate)} />
        <InfoItem label="Dollar Spend Processed Date" value={formatDateToYMD(rewardsDetails?.dollarSpendProcessedDate)} />
        <InfoItem label="Dollar Spend" value={rewardsDetails?.dollarSpend} />
        <InfoItem label="Dollar Spend Calculated" value={rewardsDetails?.dollarSpendCalculated} />
      </div>
      <div className="grid pb-6 pl-4">
        <InfoItem label="Processing Notes" value={rewardsDetails?.processingNotes} />
      </div>
    </div>

    {/* Promotional Points Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="promotional_points" title="Promotional Points" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Products" value={rewardsDetails?.products} />
        <InfoItem label="Quantity" value={rewardsDetails?.quantity} />
        <InfoItem label="Points" value={rewardsDetails?.rewardsPoints} />
        <InfoItem label="Base Points" value={rewardsDetails?.basePoints} />
        <InfoItem label="Delivery Points" value={rewardsDetails?.deliveryPoints} />
        <InfoItem label="Estimate Reward Points" value={rewardsDetails?.estimatedRewardPoints} />
        <InfoItem label="Max Multiplier" value={rewardsDetails?.maxMultiplier} />
      </div>
    </div>

    {/* Promotion Actions Table */}
    <div className="order-overview">
      <div className="grid pb-6 pl-4">
        <table className="w-full table-auto border-collapse text-left">
          <thead>
            <tr
              className="border-b"
              style={{
                borderBottom: '1.8px solid #D0D0D0',
              }}
            >
              <th className="px-4 py-2">PROMOTION ID</th>
              <th className="px-10 py-2">NAME</th>
              <th className="px-10 py-2">PROMOTION ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rewardsDetails?.usedPromotions?.map(action => (
              <tr key={action.promotionId} className="sc-border">
                <td className="cursor-pointer px-4 py-2" style={{color: '#3387DF'}}>
                  {action.promotionId}
                </td>
                <td className="px-10 py-2">{action.name}</td>
                <td className="px-10 py-2">{action.action}</td>
              </tr>
            )) || (
              <tr className="sc-border">
                <td className="px-4 py-2" colSpan="3">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </>
)

const OrderRewards = ({rewardsDetails}) => {
  return (
    <PageContainer>
      <DisplayRewards rewardsDetails={rewardsDetails} />
    </PageContainer>
  )
}

export default OrderRewards
